import { AccountsModal } from '@features/account-settings/components/AccountsModal';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/_shell/account')({ component: AccountsModal });
